module.exports = __webpack_public_path__ + "img/ad-page-bg.cb3950dd.jpg";